import React, { useState } from "react";
import { DefaultScannerComponent } from "@ingka-group-digital/flexa-scanner";
import { ScanAndSearchSlot } from "@coworker/apprestructured/src/scan-and-search/ScanAndSearchSlot";
import { ExtractedArticleInformationType } from "@coworker/apprestructured/src/scan-and-search/types/ExtractedArticleInformationType";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { useTranslation } from "@coworker/locales";

interface TestbuyItemSearchProps {
  setIsSearching: (isSearching: boolean) => void;
  handleScanResult: (productInfo: ExtractedArticleInformationType) => void;
  isSearching: boolean;
}
export const TestbuyItemSearch = ({
  handleScanResult,
  isSearching,
  setIsSearching,
}: TestbuyItemSearchProps) => {
  const { t } = useTranslation();
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  return (
    <FixaModal
      visible={isSearching}
      handleCloseBtn={() => setIsSearching(false)}
    >
      <FixaSheets
        labelledById="testbuy-item-search-modal-header"
        header={
          <FixaModalHeader
            id="testbuy-item-search-modal-header"
            title={t("replaceArticleString")}
            closeBtnClick={() => setIsSearching(false)}
          />
        }
        footer={null}
        fullSize
      >
        <DefaultScannerComponent
          onResult={handleScanResult}
          isCameraOpen={isCameraOpen}
          onCameraOpenChange={setIsCameraOpen}
          withSearchPadding
          searchSlot={
            <ScanAndSearchSlot
              onResult={handleScanResult}
              onCameraOpen={() => setIsCameraOpen(true)}
            />
          }
        />
      </FixaSheets>
    </FixaModal>
  );
};
